import axios from 'axios';
import { loginAgain, ERROR_CODE, StatusCode, goLogin } from './constant';
import { Warning } from 'components/Confirm';
import user from 'libs/user';
import { get as _get } from 'lodash';
import config from 'config';
import refresh from 'services/refresh';

const axiosInstance = axios.create({
  baseURL: config.baseURL,
  timeout: 30000
});

let isRefreshing = false;
let requests: any[] = [];

axiosInstance.interceptors.request.use(
  function (config) {
    config.headers['x-header-tid'] = user.getTenantId();
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
axiosInstance.interceptors.response.use(
  async function (response) {
    let { data, config, status } = response;
    if (status !== 200) {
      return {
        success: false
      };
    }
    const { code } = data || {};

    // token 过期,，刷新token
    if (code === StatusCode.refresh_cookies) {
      if (isRefreshing) {
        return new Promise(resolve => {
          requests.push(() => resolve(axiosInstance(config)));
        });
      }
      isRefreshing = true;
      try {
        const res: any = await refresh();
        const { data: resRefresh } = res || {};
        if (resRefresh?.code === StatusCode.need_login_again) {
          return new Promise((resolve, reject) => {
            Warning({
              title: '您的账号已在其他设备上登录',
              onOk: () => {
                requests = [];
                goLogin();
              }
            });
          });
        }
        if (resRefresh?.code === StatusCode.disabled) {
          return new Promise((resolve, reject) => {
            Warning({
              title: '该账号已被禁用，请与管理员取得联系',
              onOk: () => {
                requests = [];
                goLogin();
              }
            });
          });
        }
        if (resRefresh?.code === StatusCode.success) {
          isRefreshing = false;
          requests.forEach(cb => cb());
          requests = [];
          return axiosInstance(config);
        }
        return loginAgain();
      } catch (error) {
        return loginAgain();
      }
    }
    // token 过期,，刷新token 代码结束
    if (
      [
        StatusCode.unauthorized,
        StatusCode.invalid_token,
        StatusCode.no_auth,
        StatusCode.invalid1_token
      ].includes(code)
    ) {
      return loginAgain();
    }
    if (
      _get(response, 'headers.content-type', '').match(
        'application/vnd.ms-excel'
      )
    ) {
      return response;
    }
    if (
      _get(response, 'headers.content-type', '').match(
        'application/octet-stream'
      )
    ) {
      return response;
    }
    if (
      _get(response, 'headers.content-type', '').match('application/msword')
    ) {
      return response;
    }
    return data;
  },
  function (error) {
    if (ERROR_CODE.indexOf(error?.response?.status) !== -1) {
      // history.push('/error/500');
      Warning({
        title: `接口${error?.response?.status}`
      });
    }
    if (error?.response?.status === 404) {
      Warning({
        title: `接口${error?.response?.status}`
      });
    }
    return {
      success: false
    };
  }
);
export default axiosInstance;
